"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderRowCaret = exports.HeaderRowOptions = exports.HeaderRowTitle = exports.HeaderRowIcon = exports.HeaderRowContent = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../../styles/colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__Wrapper",
  componentId: "sc-1j7clwh-0"
})(["width:100%;height:100%;display:flex;flex-direction:row;"]);

exports.Wrapper = Wrapper;

var HeaderRowContent = _styledComponents["default"].div.withConfig({
  displayName: "styles__HeaderRowContent",
  componentId: "sc-1j7clwh-1"
})(["width:75%;display:flex;flex-direction:row;background:", ";padding:1rem 0;"], _colors["default"].blueGray.darken4);

exports.HeaderRowContent = HeaderRowContent;

var HeaderRowIcon = _styledComponents["default"].div.withConfig({
  displayName: "styles__HeaderRowIcon",
  componentId: "sc-1j7clwh-2"
})(["display:flex;justify-content:center;align-items:flex-start;width:40%;"]);

exports.HeaderRowIcon = HeaderRowIcon;

var HeaderRowTitle = _styledComponents["default"].div.withConfig({
  displayName: "styles__HeaderRowTitle",
  componentId: "sc-1j7clwh-3"
})(["text-align:center;display:flex;justify-content:center;align-items:flex-start;width:40%;"]);

exports.HeaderRowTitle = HeaderRowTitle;

var HeaderRowOptions = _styledComponents["default"].div.withConfig({
  displayName: "styles__HeaderRowOptions",
  componentId: "sc-1j7clwh-4"
})(["text-align:center;display:flex;justify-content:flex-end;align-items:flex-start;width:20%;position:relative;"]);

exports.HeaderRowOptions = HeaderRowOptions;

var HeaderRowCaret = _styledComponents["default"].div.withConfig({
  displayName: "styles__HeaderRowCaret",
  componentId: "sc-1j7clwh-5"
})(["width:25%;display:flex;flex-direction:row;justify-content:center;align-items:flex-start;background:", ";padding:1rem 0.2rem 0.2rem 0.2rem;"], _colors["default"].blueGray.darken2);

exports.HeaderRowCaret = HeaderRowCaret;